'use client'

const INTERNAL_TRAFFIC_STORAGE_KEY = 'zebra:ga-internal-traffic'

function isBrowser(): boolean {
  return typeof window !== 'undefined'
}

export function isInternalTrafficEnabled(): boolean {
  if (!isBrowser()) return false
  return window.localStorage.getItem(INTERNAL_TRAFFIC_STORAGE_KEY) === '1'
}

export function setInternalTrafficEnabled(enabled: boolean): void {
  if (!isBrowser()) return
  if (enabled) {
    window.localStorage.setItem(INTERNAL_TRAFFIC_STORAGE_KEY, '1')
    return
  }
  window.localStorage.removeItem(INTERNAL_TRAFFIC_STORAGE_KEY)
}

export function syncInternalTrafficFromQuery(
  internalParam: string | null | undefined,
): boolean {
  if (internalParam === '1') {
    setInternalTrafficEnabled(true)
    return true
  }

  if (internalParam === '0') {
    setInternalTrafficEnabled(false)
    return false
  }

  return isInternalTrafficEnabled()
}

export function getInternalTrafficStorageKey(): string {
  return INTERNAL_TRAFFIC_STORAGE_KEY
}
